<template>
  <!-- GALERÍA VERTICAL -->
  <section ref="galleryRef" class="gallery-section">

    <div class="photo-item" ref="photo1">
      <img src="@/assets/IMG_4917.webp" alt="Foto 1" />
    </div>

   

  </section>
</template>

<script>
import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'GaleriaVerticalAnimada',
  setup() {
    const galleryRef = ref(null)
    const photo1 = ref(null)
    const photo2 = ref(null)
    const photo3 = ref(null)

    onMounted(async () => {
      await nextTick()

      // Estado inicial
      gsap.set([photo1.value, photo2.value, photo3.value], {
        opacity: 0,
        y: 60,
        scale: 0.95
      })

      // Animación al entrar al viewport
      gsap.timeline({
        scrollTrigger: {
          trigger: galleryRef.value,
          start: 'top 80%',
          toggleActions: 'play none none reset'
        }
      })
      .to(photo1.value, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.9,
        ease: 'power3.out'
      })
      .to(photo2.value, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.9,
        ease: 'power3.out'
      }, '>-0.4')
      .to(photo3.value, {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.9,
        ease: 'power3.out'
      }, '>-0.4')
    })

    onBeforeUnmount(() => {
      ScrollTrigger.getAll().forEach(t => t.kill())
    })

    return {
      galleryRef,
      photo1,
      photo2,
      photo3
    }
  }
}
</script>

<style scoped>
/* ===== GALERÍA ===== */
.gallery-section {

  background-image: 
    linear-gradient(to bottom, 
      rgba(0, 0, 0, 0.945) 60%, 
      rgba(0, 0, 0, 0.7) 85%, 
      rgba(0, 0, 0, 0.95) 100%
    ),
    url('@/assets/descarga (3) - copia - copia.png');

  background-size: cover;
  background-position: center center; 
  background-repeat: no-repeat;  padding: 30px 14px 60px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ===== FOTO ===== */
.photo-item {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 6px;
}

.photo-item img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
</style>
